import type { PreferenceTile } from "components/Screens/Marketplace/Customer/types";
import type { PlgSignupConfig } from "plg/types";

/** A "what you are looking for" tile from PLG_SIGNUP_CONFIG.preferences. `cat` carries the tile key. */
export interface PreferenceTileView extends PreferenceTile {
  icon: string;
}

export type PreferenceCopyKey = "ask1" | "ask2" | "ask3" | "recommend" | "company";

const NUM_WORDS = ["no", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];

export const andList = (a: string[]) => (a.length > 1 ? `${a.slice(0, -1).join(", ")} and ${a[a.length - 1]}` : a[0] || "");

/** The one fixed tile set, used by preference asks 1-3, Have Edge recommend and the Company page. */
export function configTiles(config: PlgSignupConfig | null | undefined): PreferenceTileView[] {
  return (config?.preferences?.tiles || []).map((t) => ({ cat: t.key, label: t.label, icon: t.icon }));
}

export const preferenceTitle = (config: PlgSignupConfig | null | undefined) => config?.preferences?.title || "";

/** Subtitle for a context; `{count}` / `{people}` are filled from the shortlist size. */
export function preferenceSubtitle(config: PlgSignupConfig | null | undefined, key: PreferenceCopyKey, count = 0): string {
  const raw = config?.preferences?.subtitles?.[key] || "";
  return raw.replace("{count}", NUM_WORDS[count] || String(count)).replace("{people}", count === 1 ? "person" : "people");
}
